import React, { memo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { STATIC_TEXTS } from "@cart-client/constants/GiftingCart";

interface HeaderAlertTextProps {
    text?: string;
}

const HeaderAlertText = ({ text = STATIC_TEXTS.HEADER_OOS }: HeaderAlertTextProps) => {
    return (
        <Text variant="V2.body1.neutral.bold" color="negative">
            {text}
        </Text>
    );
};

export default memo(HeaderAlertText);
